import { render } from "./dlg-user.vue?vue&type=template&id=4491da40"
import script from "./dlg-user.vue?vue&type=script&lang=js"
export * from "./dlg-user.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__